import { useAnalyticsImpressionsStore } from 'analytics/stores/analyticsImpressions'

export const useImpressionCount = () =>
	useAnalyticsImpressionsStore((state) => state.impressions.length)
